export enum FormOption {
  CHANGE_ATTRIBUTES = 'change_attributes',
  CHANGE_PASSWORD = 'change_password',
}
